import styled, {css} from 'styled-components';

export const PasswordMessage = styled.div`
  padding: 10px;
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 1px solid #D9D9D9;
  position: relative;

  &:before {
    content: ' ';
    position: absolute;
    background: white;
    width: 13px;
    height: 13px;
    top: -8px;
    left: 10px;
    transform: rotate(45deg);
    border: 1px solid #D9D9D9;
    border-width: 1px 0 0px 1px;
  }

  margin-top: 20px;
  ${({lateral}) => lateral && css`
    @media (min-width: 1200px) {
      margin-top: 0px;
      position: absolute;
      left: 100%;
      width: 251px;
      margin-left: 19px;
      top: 0;
      line-height: 16px;
      &:before {
        left: -7px;
        top: 13px;
        border-width: 0px 0 1px 1px;
      }
    }
  `}
`;
